<template>
  <div v-if="message.media_type === 'image'" class="text-center">
    <ImageView v-on:image-width="passWidth" :url="message.media_uri" />
  </div>
  <div v-if="message.media_type === 'video'">
     <video width="320" height="240" controls>
        <source v-bind:src="message.media_uri" type="video/mp4">
     </video>
  </div>
  <div v-if="message.media_type === 'file'">
     <a v-bind:href="message.media_uri" target="_blank" class="font-bold">{{ $t('conversation.downloadAttachment') }}</a>
  </div>
</template>

<script>
import ImageView from './ImageView.vue'

export default {
  name: 'FileAttachments',
  emits: ['image-width'],
  props: ['message'],
  components: {
    ImageView,
  },
  methods: {
    passWidth(width) {
      this.$emit('image-width', width);
    },
  },
}
</script>
